import React from 'react';
import { Platform, StatusBar as RNStatusBar } from 'react-native';
import { useTheme } from '../context/ThemeContext';
import { HEADER_BACKGROUND } from '../theme/palettes';

/**
 * Keeps the OS status bar area the same color as in-app headers (mobile only).
 */
const HeaderStatusBar = () => {
  const { colors } = useTheme();
  const backgroundColor = colors.primary.header || HEADER_BACKGROUND;

  if (Platform.OS === 'web') {
    return null;
  }

  return (
    <RNStatusBar
      barStyle="light-content"
      backgroundColor={backgroundColor}
      translucent={false}
    />
  );
};

export default HeaderStatusBar;
